import { render, staticRenderFns } from "./home.vue?vue&type=template&id=059fcba2&scoped=true&xmlns%3Ahttp=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059fcba2",
  null
  
)

export default component.exports